import { render, staticRenderFns } from "./ReassignPermission.vue?vue&type=template&id=d6d33732&"
import script from "./ReassignPermission.vue?vue&type=script&lang=js&"
export * from "./ReassignPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports